import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import Waiting from '../components/waiting';
import { querystring } from '../utils/helpers';
import { useStores } from '../hooks/use-stores';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

function SignIn() {
    const { authStore } = useStores();
    const navigate = useNavigate();
    const { token } = useParams();
    const location = useLocation();

    useEffect(() => {
        if (!token) return;
        const urlForQuery = location.pathname + (location.search || '');
        let redirect = querystring('redirect', urlForQuery || window.location.href) || '/';
        if (redirect === 'undefined') redirect = '/';
        if (redirect === 'null') redirect = '/';
        if (!redirect.startsWith('/')) redirect = `/${redirect}`;

        const hadToken = !!authStore.token;
        authStore.exchangeJwtSignin(token).then((result) => {
            if (result.success) {
                navigate(redirect);
            } else if (hadToken) {
                // Exchange failed but user was already logged in: keep existing token, ignore error, go to redirect
                navigate(redirect);
            } else if (result.expired) {
                authStore.setError(result.message, 'emailLogin');
                navigate(`/auth/signin?expired=1&redirect=${encodeURIComponent(redirect)}`);
            } else {
                navigate(`/auth/signin?redirect=${encodeURIComponent(redirect)}`);
            }
        });
    }, [token, location.search, location.pathname]);

    return <Waiting waitingActive={true} from={'TokenSignIn'} />;
}

export default observer(SignIn);
